<template>
  <div class="cont-box">
    <img src="../assets/img/shareText.png" alt />
    <div class="text-box-cont">
      <p class="friends" v-if="pageType">
        您的好友：
        <span>{{ userName }}</span>
      </p>
      <p :class="pageType ? 'invitation' : 'invitation-only'">
        <span>邀请您加入：【</span
        ><img :src="applicationHeadPath" alt="" width="15" height="15" /><span
          >{{ appName }}】</span
        >
      </p>
      <p class="invitation-title" v-if="pageType">邀请码</p>
      <p class="invitation-code" v-if="pageType">{{ invCode }}</p>
      <p class="invitation-code-cope" @click="copeFun" v-if="pageType">
        点击复制
      </p>
      <div class="invitation-line"></div>
      <a href="javascript:;" @click="downApp" v-if="type == 0||type == 3" class="IOS-btn">
        <img src="../assets/img/IOSIcon.png" alt />IOS下载
      </a>
      <a
        href="javascript:;"
        @click="downApp"
        v-if="type == 1||type == 3"
        class="Android-btn"
      >
        <img src="../assets/img/AndroidIcon.png" alt />Android下载
      </a>
    </div>
  </div>
</template>

<script>
// 地址  http://192.168.1.17:8080/invitation?bundleID=MJNewMedia&type=1&invCode=12312131221
import { getAppUrl, addCount } from "../service/share";
import copy from "copy-to-clipboard";
export default {
  data() {
    return {
      Url: "",
      type: 0,
      appName: "",
      applicationHeadPath: "",
    };
  },
  computed: {
    userName() {
      if (this.$route.query.userName) {
        return this.$route.query.userName;
      } else {
        return "";
      }
    },

    invCode() {
      if (this.$route.query.invCode) {
        return this.$route.query.invCode;
      } else {
        return "";
      }
    },
    pageType() {
      if (this.$route.query.type == 1) { // 好友邀请下载
        return true;
      } else { // 邀请下载
        return false;
      }
    },
  },
  mounted() {
    if (this.equipmentType() == "iOS") {
      this.type = 0;
    } else if (this.equipmentType() == "Android") {
      this.type = 1;
    } else { 
      this.type = 3;
    }
    console.log(this.equipmentType());
    // if (this.equipmentType() == "iOS") {
    //   this.type = 0;
    // } else{
    //   this.type = 1;
    // }
    this.getRem(750, 100);
    window.onresize = () => {
      this.getRem(750, 100);
    };
    document.title = "邀请您加入";
    getAppUrl({ type: this.type, bundleID: this.$route.query.bundleID }).then(
      ({ data }) => {
        if (data.status == 0) {
          // this.webcommentList = data.data;
          if (data.data) {
            this.Url = data.data.versionUrl;
            this.appName = data.data.applicationName;
            this.applicationHeadPath = data.data.applicationHeadPath;
          }
        } else {
          console.log(data.desc);
        }
      }
    );
  },
  methods: {
    getRem(pwidth, prem) {
      let html = document.getElementsByTagName("html")[0];
      let oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = (oWidth / pwidth) * prem + "px";
    },  
    copyFun(content) {
      let aux = document.createElement("input");
      aux.setAttribute("value", content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      alert("复制成功" + content);
    },
    equipmentType() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return "Android";
      } else if (isiOS) {
        return "iOS";
      } else {
        return "noMobileDevices";
      }
    },
    copeFun() {
      if (copy(this.invCode)) {
        alert("复制成功");
      } else {
        alert("复制失败");
      }
    },
    downApp() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      addCount(
        this.$route.query.bundleID,
        isAndroid ? 1 : isiOS ? 0 : ""
      ).then(({ data }) => {});
      let string = '';
      let obj = {
        appName: this.appName,
        Invitation: this.invCode
      }
      string = 'YQXZ|'+ JSON.stringify(obj) + '|YQXZ';
      copy(string);
      if (isAndroid) {
        let ua = navigator.userAgent.toLowerCase();
        let isWeixin = ua.indexOf("micromessenger") != -1;
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面下载app");
        } else {
          window.location.href = this.Url;
        }
      } else if (isiOS) {
        // console.log(this.Url);
        window.location.href = this.Url;
      } else {
        // alert("请使用手机打开本页面。");
        window.location.href = this.Url;
      }
    },
  },
};
</script>

<style scope>
.cont-box {
  padding: 0.3rem;
  min-height: 100vh;
  background: url(../assets/img/shareNubBG.png) no-repeat center center / cover;
  box-sizing: border-box;
  overflow: hidden;
}
.cont-box > img {
  display: block;
  width: 4rem;
  margin: 0.9rem auto;
}
.text-box-cont {
  overflow: hidden;
  padding: 0.7rem 0;
  background-color: #fff;
  border-radius: 0.1rem;
  margin-bottom: 1rem;
}
.friends {
  font-size: 0.28rem;
  color: #3a8aee;
  text-align: center;
  margin-bottom: 0.2rem;
}
.friends > span {
  color: #333;
}
.invitation {
  height: 0.3rem;
  font-size: 0.28rem;
  color: #333;
  text-align: center;
  margin-bottom: 0.54rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.invitation-only {
  height: 1rem;
  font-size: 0.32rem;
  color: #333;
  text-align: center;
  margin-bottom: 0.54rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.invitation-title {
  font-size: 0.36rem;
  color: #3a8aee;
  text-align: center;
  margin-bottom: 0.28rem;
}
.invitation-code {
  font-size: 0.7rem;
  color: #3a8aee;
  text-align: center;
  margin-bottom: 0.28rem;
  font-weight: bold;
  letter-spacing: 0.1rem;
}
.invitation-code-cope {
  display: block;
  margin: 0 auto;
  width: 2.8rem;
  height: 0.68rem;
  background-color: #3a8aee;
  color: #fff;
  text-align: center;
  line-height: 0.68rem;
  border-radius: 0.34rem;
  font-size: 0.28rem;
  text-decoration: none;
}
.invitation-line {
  width: 100%;
  height: 0;
  display: block;
  margin: 0.5rem 0;
  border-bottom: 1px dashed #000;
  position: relative;
}
.invitation-line::before {
  content: "";
  width: 0.3rem;
  height: 0.3rem;
  background-color: #2850e7;
  position: absolute;
  left: -0.15rem;
  top: -0.15rem;
  border-radius: 50%;
}
.invitation-line::after {
  content: "";
  width: 0.3rem;
  height: 0.3rem;
  background-color: #2850e7;
  position: absolute;
  right: -0.15rem;
  top: -0.15rem;
  border-radius: 50%;
}
.IOS-btn,
.Android-btn {
  width: 3.4rem;
  height: 0.7rem;
  margin: 0 auto 0.34rem;
  font-size: 0.3rem;
  display: block;
  text-align: center;
  color: #3a8aee;
  text-decoration: none;
  border-radius: 0.35rem;
  border: 2px solid #3a8aee;
  display: flex;
  justify-content: center;
  align-items: center;
}
.IOS-btn > img,
.Android-btn > img {
  height: 0.34rem;
  margin-right: 0.1rem;
  display: inline-block;
}
</style>
